import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ExitToApp';

class ExitToAppIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ExitToAppIcon;
